import React, {useContext} from "react";
import BusinessServiceContext from "../../../../../providers/Service/business";
import {Schedule} from "../../../Shared/Schedule";
export const ServiceSchedules = () => {
  const {service} = useContext(BusinessServiceContext);
  return <Schedule schedule={service.schedule} />;
};
